"use client";

// The shared public-rental components are written for any React host and carry no client directive. This module is the
// boundary: everything re-exported here is a Client Component, so Server Components can render it with serializable props.
export { PublicRentalPage } from "@unitfield/ui/public-rental/rental-applications/page-frame";
export { PublicRentalApplicationsListingView } from "@unitfield/ui/public-rental/rental-applications/listing-core";
export { PublicRentalUnitView } from "@unitfield/ui/public-rental/rental-applications/unit-core";
export { PublicPropertyView } from "@unitfield/ui/public-rental/rental-applications/property-view";
export { SignInFrame, SignInEmailScreen, CodeScreen } from "@unitfield/ui/public-rental/rental-applications/apply/apply-screens";
export { GoogleSignInButton } from "@unitfield/ui/public-rental/rental-applications/apply/google-sign-in-button";
export { PublicBrandProvider } from "@unitfield/ui/public-rental/shell/public-brand-provider";
export { PublicRentalApplicationApply } from "@/features/apply/apply-core";
export { ArkToaster } from "@unitfield/ui/ark-toast";
export { ApplicantContinuationView } from "@unitfield/ui/public-rental/rental-applications/continuation-page";
